import { ReactNode } from "react";

interface TableCellProps {
  children: ReactNode;
  className?: string;
  visibilityClass?: string;
  onClick?: (e: React.MouseEvent) => void;
  stopPropagation?: boolean;
}

export function TableCell({
  children,
  className = "",
  visibilityClass = "",
  onClick,
  stopPropagation = false,
}: TableCellProps) {
  return (
    <td
      valign="middle"
      className={`align-middle py-2 px-3 ${visibilityClass} ${className}`}
      onClick={(e) => {
        if (stopPropagation) {
          e.stopPropagation();
        }
        if (onClick) {
          onClick(e);
        }
      }}
    >
      {children}
    </td>
  );
}
